// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="0"]),
.ids-layout-flex-item-flex-0 {
  flex: 0;
  min-width: 0;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
  min-width: 0;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
  min-width: 0;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
  min-width: 0;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
  min-width: 0;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
  min-width: 0;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
  min-width: 0;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
  min-width: 0;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
  min-width: 0;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
  min-width: 0;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
  min-width: 0;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
  min-width: 0;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
  min-width: 0;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
  min-width: 0;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
  min-width: 0;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
  min-width: 0;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
  min-width: 0;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
  min-width: 0;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
  min-width: 0;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
  min-width: 0;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
  min-width: 0;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
  min-width: 0;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
  min-width: 0;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
  min-width: 0;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
  min-width: 0;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-flex/ids-layout-flex-item.scss"],"names":[],"mappings":"AAAA,mCAAA;AAME;;EAEE,gBALc;AAClB;;AAEE;;EAEE,oBALc;AAMlB;;AAHE;;EAEE,kBALc;AAWlB;;AARE;;EAEE,mBALc;AAgBlB;;AAbE;;EAEE,sBALc;AAqBlB;;AAlBE;;EAEE,oBALc;AA0BlB;;AAbE;;EAEE,YALa;AAqBjB;;AAlBE;;EAEE,YALa;AA0BjB;;AAbE;;EAEE,cALe;AAqBnB;;AAlBE;;EAEE,cALe;AA0BnB;;AAbE;;EAEE,OALQ;EAMR,YAAA;AAgBJ;;AAnBE;;EAEE,OALQ;EAMR,YAAA;AAsBJ;;AAzBE;;EAEE,OALQ;EAMR,YAAA;AA4BJ;;AA/BE;;EAEE,OALQ;EAMR,YAAA;AAkCJ;;AArCE;;EAEE,OALQ;EAMR,YAAA;AAwCJ;;AA3CE;;EAEE,OALQ;EAMR,YAAA;AA8CJ;;AAjDE;;EAEE,OALQ;EAMR,YAAA;AAoDJ;;AAvDE;;EAEE,OALQ;EAMR,YAAA;AA0DJ;;AA7DE;;EAEE,OALQ;EAMR,YAAA;AAgEJ;;AAnEE;;EAEE,OALQ;EAMR,YAAA;AAsEJ;;AAzEE;;EAEE,QALQ;EAMR,YAAA;AA4EJ;;AA/EE;;EAEE,QALQ;EAMR,YAAA;AAkFJ;;AArFE;;EAEE,QALQ;EAMR,YAAA;AAwFJ;;AA3FE;;EAEE,QALQ;EAMR,YAAA;AA8FJ;;AAjGE;;EAEE,QALQ;EAMR,YAAA;AAoGJ;;AAvGE;;EAEE,QALQ;EAMR,YAAA;AA0GJ;;AA7GE;;EAEE,QALQ;EAMR,YAAA;AAgHJ;;AAnHE;;EAEE,QALQ;EAMR,YAAA;AAsHJ;;AAzHE;;EAEE,QALQ;EAMR,YAAA;AA4HJ;;AA/HE;;EAEE,QALQ;EAMR,YAAA;AAkIJ;;AArIE;;EAEE,QALQ;EAMR,YAAA;AAwIJ;;AA3IE;;EAEE,QALQ;EAMR,YAAA;AA8IJ;;AAjJE;;EAEE,QALQ;EAMR,YAAA;AAoJJ;;AAvJE;;EAEE,QALQ;EAMR,YAAA;AA0JJ;;AA7JE;;EAEE,QALQ;EAMR,YAAA;AAgKJ;;AAxJE;;EAEE,cALY;AAgKhB;;AA7JE;;EAEE,gBALY;AAqKhB;;AAlKE;;EAEE,iBALY;AA0KhB;;AAvKE;;EAEE,gBALY;AA+KhB;;AApKA;;EAEE,WAAA;AAuKF;;AApKA;EACE,qBAAA;AAuKF","sourcesContent":["/* Ids Layout Flex Item Component */\n\n// Align-self\n$align-self-list: auto baseline center stretch flex-start flex-end;\n\n@each $align-self in $align-self-list {\n  :host([align-self='#{$align-self}']),\n  .ids-layout-flex-item-align-self-#{$align-self} {\n    align-self: $align-self;\n  }\n}\n\n// Flex-grow\n$flex-grow-list: 0 1;\n\n@each $flex-grow in $flex-grow-list {\n  :host([grow='#{$flex-grow}']),\n  .ids-layout-flex-item-grow-#{$flex-grow} {\n    flex-grow: $flex-grow;\n  }\n}\n\n// Flex-shrink\n$flex-shrink-list: 0 1;\n\n@each $flex-shrink in $flex-shrink-list {\n  :host([shrink='#{$flex-shrink}']),\n  .ids-layout-flex-item-shrink-#{$flex-shrink} {\n    flex-shrink: $flex-shrink;\n  }\n}\n\n// Flex\n$flex-list: 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24;\n\n@each $flex in $flex-list {\n  :host([flex='#{$flex}']),\n  .ids-layout-flex-item-flex-#{$flex} {\n    flex: $flex;\n    min-width: 0;\n  }\n}\n\n// Overflow\n$overflow-list: auto hidden visible scroll;\n\n@each $overflow in $overflow-list {\n  :host([overflow='#{$overflow}']),\n  .ids-layout-flex-item-overflow-#{$overflow} {\n    overflow: $overflow;\n  }\n}\n\n// grow/shrink=0 override - class-based workaround for container grid collapse\n// Note: :has(::slotted()) is invalid CSS due to Shadow DOM spec limitations\n:host(.has-container-grid[grow='0'][shrink='0']),\n.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {\n  width: 100%;\n}\n\n::slotted(ids-input[size=\"full\"]) {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
